// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object, string } from 'prop-types'
import Th from './Th'

const THead = ({ columns, customProps, idRoot, handleSort, tableSort, unitType }) => (
  <thead className={'heading-font bg-blue-dark'}>
    <tr>
      {columns.map(d => (
        <Th
          key={d.columnKey}
          {...d}
          customProps={customProps}
          idRoot={idRoot}
          tableSort={tableSort}
          handleSort={handleSort}
          unitType={unitType} />
      ))}
    </tr>
  </thead>
)

THead.propTypes = {
  columns: array.isRequired,
  customProps: object,
  idRoot: string.isRequired,
  handleSort: func,
  tableSort: object,
  unitType: string,
}

export default THead
